import type {Elements} from '@kontent-ai/delivery-sdk';
export const isEmpty = (value: string | undefined) => {
  if (!value) return true
  return value == '<p><br></p>'
}

export const multipleChoiceToBoolean = (element: Elements.MultipleChoiceElement) => {
  if (!element) return false
  return element.value.length > 0
    ? element.value[0].codename == 'yes' ||
        element.value[0].codename == 'show' ||
        element.value[0].codename == 'expanded'
    : false
}

export const toSiteDateString = (date: Date | undefined) => {
  if (date) {
    return `${getMonth(date.getMonth())} ${date.getDate()}, ${date.getFullYear()}`
  }

  return ''
}

export const formatDateStringWithTimezone = (isoDate: string, timeZone: string) => {
  const date = new Date(isoDate)

  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZoneName: "long"
  }).formatToParts(date)

  const map = Object.fromEntries(parts.map((p) => [p.type, p.value]))
  return `${map.month} ${map.day}, ${map.year}`
}

export const  formatWithTimezone = (isoDate: string, timeZone: string) => {
  const date = new Date(isoDate)

  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone,
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZoneName: 'longGeneric'
  }).formatToParts(date)

  const map = Object.fromEntries(parts.map((p) => [p.type, p.value]))

  const period = map.dayPeriod === 'AM' ? 'A.M.' : 'P.M.'
  const region = map.timeZoneName.replace(' Time', '')

  return `${map.month} ${map.day}, ${map.year} at ${map.hour}:${map.minute} ${period} ${region}`
}



export const getMonth = (m: number) => {
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ]

  return months[m]
}
